export const TRANSLATE_KEYS_PT_BR = {
  //Login
  login_email: 'E-mail',
  login_senha: 'Senha',
  entrar: 'Entrar',
  esqueci_minha_senha: 'Esqueceu sua senha',

  //Recuperar Senha
  recuperar_senha_email: 'E-mail',
  recuperar_senha: 'Recuperar senha',
  voltar_login: 'Voltar para o login',
  recuperar_senha_mensagem_aviso: 'Não se preocupe. Basta inserir seu e-mail abaixo e enviaremos um link para recuperar seu acesso.',

  // Cadastro de senhas
  gerenciar_senhas_criar_senha: 'Cadastrar senha',
  gerenciar_senhas_titulo: 'Criar senha',

  // Placeholders
  placeholder_email: 'Digite aqui seu e-mail',
  placeholder_senha: 'Digite aqui sua senha',
  placeholder_documento: 'Digite aqui o seu documento',
  placeholder_celular: 'Digite o número do seu telefone',
  placeholder_empresa: 'Escreva aqui o nome da sua empresa',
  placeholder_selecione: 'Selecione',
  placeholder_cargo: "Digite aqui seu cargo",
  placeholder_nome_empresa: "Digite aqui o nome da empresa",
  placeholder_cnpj_empresa: "Digite aqui o CNPJ da empresa",

  // Perfil
  perfil_cadastre_foto: 'Cadastre sua foto',
  perfil_dados_pessoais: 'Dados pessoais',
  perfil_confira_seus_dados: 'Confira seus dados registrados e atualize-os caso necessário.',
  perfil_alterar_dados: 'Alterar dados',
  perfil_email: 'E-mail',
  perfil_senha: 'Senha',
  perfil_confirmar_senha: 'Confirmar senha',
  perfil_direitos_autorais_rodape: 'Copyright ©2000 - 2025.',
  perfil_todos_direitos_reservados_rodape: 'Todos os direitos reservados.',
  perfil_isencao_responsabilidade_conteudo_rodape: 'Todo o conteúdo do site, todas as fotos, imagens, conjuntos de imagem, layouts, trade dress, aqui veiculados são meramente ilustrativos e de propriedade exclusiva do Grupo Imply ou de seus parceiros.',
  perfil_isencao_responsabilidade_reproducao_rodape: 'É vedada qualquer reprodução, total ou parcial, de qualquer elemento de identidade, sem expressa autorização.',
  perfil_isencao_responsabilidade_violacao_rodape: 'A violação de qualquer direito mencionado implicará na responsabilização cível e criminal nos termos da Lei.',
  perfil_informacoes_imply_rodape: 'Imply Rental Loc. de Equip. e Serv. | CNPJ: 14.928.256/0001-78 | Rod. Imply Tecnologia, 1.111',
  perfil_requisito_letra_minuscula: 'Letra minúscula',
  perfil_requisito_letra_maiuscula: 'Letra maiúscula',
  perfil_requisito_incluir_numeros: 'Incluir números',
  perfil_requisito_caracter_especial: 'Caracterer especial',
  perfil_requisito_mais_de_8_digitos: 'Mais de 8 dígitos',
  perfil_requisito_confirmar_senha_igual: 'Senhas iguais',
  perfil_requisito_sem_espacos: 'Senha não pode conter espaços',
  perfil_salvar_atualizacao: 'Salvar atualização',
  perfil_cancelar_alteracao: 'Cancelar alteração',
  perfil_boas_vindas: 'Olá',
  perfil_alterar_senha: 'Alterar senha',
  perfil_sucesso_alterar_senha: 'Senha alterada com sucesso!',
  perfil_nivel_permissao: 'Nível de permissão',
  instituicao_ensino: 'Instituição de ensino.',

  //Eventos
  eventos_ativos: 'Eventos ativos',
  eventos_inativos: 'Eventos inativos',

  //Detalhes do evento
  incluir_colaboradores: 'Incluir colaboradores',
  status_negado: 'Negado',
  status_pendente: 'Pendente',
  status_removido: 'Removido',
  status_aprovado: 'Aprovado',
  nenhum_colaborador_evento: 'Nenhum colaborador no evento',
  incluir_veiculos: 'Incluir veículos',
  nenhum_veiculo_evento: 'Nenhum veículo no evento',
  colaboradores: 'Colaboradores',
  nenhum_colaborador_disponivel: 'Nenhum colaborador disponível',
  veiculos: 'Veículos',
  nenhum_veiculo_disponivel: 'Nenhum veículo disponível',
  aguardando_aprovacao_do_gestor_do_evento: 'Aguardando aprovação do gestor do evento',
  gestor_negou_a_devida_solicitacao: 'O gestor negou a solicitação de acesso para o devido colaborador / Veiculo',
  este_colaborador_foi_removida_a_autorizacao_pelo_permissionario: 'Foi removido a solicitação pelo permissionário',
  remove_solicitacao_de_autorizacao_do_acesso: 'Remove a solicitação de acesso e bloqueia o acesso caso tenha sido previamente aprovado',
  baixa_arquivo_de_autorizacao: 'Baixa o arquivo para impressão',
  envia_um_email_com_anexo_para_o_colaborador: 'Envia o arquivo para impressão direto para o e-mail informado no momento do cadastro do colaborador',
  informacoes: 'Informações',
  solicitar_novamente_autorizacao: 'Solicitar novamente a aprovação do acesso',
  deseja_remover_a_solicitacao_do_evento_para_o_colaborador: 'Deseja remover a solicitação de acesso? (Caso tenha sido previamente autorizado o acesso sera bloqueado)',
  deseja_enviar_email_para_o_colaborador_selecionado: 'Deseja enviar um e-mail para o colaborador selecionado?',
  acesso_enviao_para_o_email_colaborador: 'E-mail enviado com sucesso',
  caso_o_email_existir_sera_enviado_email: 'Caso o e-mail informado esteja correto, sera enviado um e-mail para o mesmo com a nova senha, confirmar envio da nova senha?',
  acesso_enviado_pelo_email: 'Acesso enviado para o e-mail do colaborador!',

  // Colaboradores
  colaborador: 'Colaborador',
  colaborador_ver_todos: 'Ver todos os colaboradores',
  colaborador_incluir_novo: 'Incluir novos colaboradores',

  //Listagem de colaboradores
  buscar_colaborador: 'Buscar colaborador',
  buscar_permissionario: 'Buscar por permissionário',
  cadastrar: 'Cadastrar',
  atencao: 'Atenção',
  deseja_excluir_colaborador: 'Deseja excluir o colaborador ',
  deseja_excluir: 'Deseja excluir ',
  cancelar: 'Cancelar',
  confirmar: 'Confirmar',
  colaborador_placeholder_nome_colaborador: 'Digite aqui o nome do colaborador',
  colaborador_placeholder_email_colaborador: 'Digite aqui o e-mail do colaborador',
  colaborador_importar_lista: 'Importar lista de colaboradores',
  colaborador_importar_lista_suporte_csv: 'Suporte apenas para arquivos CSV',
  colaborador_total_cadastros: 'Total de pessoas cadastradas',
  colaborador_com_onboarding: 'Com Onboarding',
  colaborador_sem_onboarding: 'Sem Onboarding',
  buscar_empresa: 'Buscar empresas',
  onboarding: 'Onboarding',
  possui_onboarding: 'Possui onboarding?',

  //Cadastro de colaboradores
  cadastrar_colaborador: 'Cadastrar colaborador',
  editar_colaborador: 'Editar colaborador',
  documento: 'Documento',
  nome: 'Nome',
  cadastro_email: 'E-mail',
  telefone: 'Celular',
  sucesso: 'Sucesso',
  colaborador_cadastrado_sucesso: 'Colaborador cadastrado com sucesso!',
  colaborador_editado_sucesso: 'Colaborador editado com sucesso!',
  finalizar: 'Finalizar',
  ocorreu_erro_cadastro: 'Não foi possível finalizar o cadastro no momento. Tente novamente.',
  ok: 'Ok',
  colaborador_nome_limitado_150_characteres: 'Nome: Máximo de 150 characteres atingido',
  colaborador_email_limitado_100_characteres: 'E-mail: Máximo de 100 characteres atingido',
  colaborador_informe_nome_completo: 'Informe nome completo',
  informe_um_celular_valido: 'Informe um numero válido',
  informe_um_documento_valido: 'Informe um documento válido',
  informe_um_email_valido: 'Informe um E-mail válido',
  editar: 'Editar',
  informe_todos_os_campos: 'Informe todos os campos!',
  colaborador_ponto_focal: 'Ponto focal',
  colaborador_deletado_sucesso: 'Colaborador deletado com sucesso!',

  //Visitantes
  visitante_visita_singular: 'Visita',
  visitante_inicio_visita: 'Início da visita',
  visitante_fim_visita: 'Fim da visita',
  visitante_agendar_visita: 'Agendar mais uma visita',
  visitante_remover_visita: 'Remover visita adicionada',
  visitante_informacao_inputs: 'Informe o nome e e-mail do visitante que deseja convidar.',
  visitante_importar_lista: 'Importar lista de visitantes',
  visitante_importar_lista_suporte_csv: 'Suporte apenas para arquivos CSV',
  visitante_botao_enviar: 'Enviar convite(s)',
  visitante_placeholder_nome_visitante: 'Digite aqui o nome do visitante',
  visitante_placeholder_email_visitante: 'Digite aqui o e-mail do visitante',
  visitante_data_invalida: 'A data / hora inicial não pode ser maior que a data final.',
  visitante_inclusao_data_inicio: 'Data inicial da inclusão',
  visitante_inclusao_data_fim: 'Data final da inclusão',
  visitante_mostrar_filtros: 'Mais filtros',
  visitante_ocultar_filtros: 'Ocultar filtros',
  visitante_periodo_visita: 'Status período de visita',
  buscar_visitante: "Buscar visitante",
  visitante_agenda_visitas: 'Visitas',
  visitante_deletar: "Deletar visitante",
  visitante_visita_atualizada: "Visita atualizada com sucesso!",
  visitante_incluir_novo: 'Incluir novos visitantes',
  deseja_excluir_visitante: 'Deseja excluir o visitante ',
  visitante_ver_todos: 'Ver todos os visitantes',

  //Alunos
  buscar_aluno: 'Buscar aluno',
  aluno_incluir_novo: 'Incluir novos alunos',
  aluno_informacao_inputs: 'Informe o nome e e-mail do aluno que deseja convidar.',
  aluno_placeholder_email_aluno: 'Digite aqui o e-mail do aluno',
  aluno_placeholder_nome_aluno: 'Digite aqui o nome do aluno',
  aluno_importar_lista: 'Importar lista de alunos',
  aluno_ver_todos: 'Ver todos os alunos',
  deseja_excluir_aluno: 'Deseja excluir o aluno ',
  visitante_preencha_campos: 'Preencha as datas acima para prosseguir',
  corrija_erro_data_para_prosseguir: 'Corrija os conflitos de datas para prosseguir',
  conflito_datas: 'Há um conflito entre as datas, corrija-os para prosseguir',

  //Listagem de veículos
  buscar_veiculo: 'Buscar veículo',
  deseja_excluir_veiculo: 'Deseja excluir o veículo?',

  //Cadastro de veículos
  cadastrar_veiculo: 'Cadastrar veículo',
  veiculo_marca_modelo: 'Marca / Modelo',
  veiculo_cor: 'Cor',
  veiculo_placa: 'Placa',
  veiculo_status: 'Status',
  ativo: 'Ativo',
  inativo: 'Inativo',
  veiculo_tipo: 'Tipo',
  veiculo_automovel: 'Automóvel',
  veiculo_motocicleta: 'Motocicleta',
  veiculo_caminhao: 'Caminhão',
  veiculo_cadastrado_sucesso: 'Veículo cadastrado com sucesso!',
  veiculo_editado_sucesso: 'Veículo editado com sucesso!',
  veiculo_placa_minimo_4_maximo_50: 'Informe uma placa válida, mínimo: 4 Máximo: 50',
  veiculo_cor_50_characteres: 'Informe uma cor válida, Máximo: 50',
  veiculo_marca_modelo_minimo_4_maximo_50: 'Informe uma Marca/Modelo válida, mínimo: 4 Máximo: 50',

  //Sucesso
  sucesso_convite_enviado: 'Envio de convite realizado com sucesso',
  sucesso_tudo_pronto: 'Tudo pronto!',
  sucesso_voltar: 'Voltar',
  sucesso_voltar_login: 'Voltar para login',
  sucesso_mensagem_verificar_spam: 'Caso não encontre nenhum e-mail na sua caixa de entrada, verifique também a lista de spam',
  sucesso_pronto_acesso_caldeira: 'Você está pronto(a) para acessar ao Caldeira com sua facial',

  //Onboard
  onboard_label_selecione_genero: 'Selecione o seu gênero',
  onboard_label_selecione_tipo_documento: 'Selecione o tipo do seu documento',
  onboard_label_documento: 'Documento',
  onboard_label_celular: 'Celular',
  onboard_label_empresa: 'Sua empresa',
  onboard_label_data_nascimento: 'Data de nascimento',
  onboard_label_cargo: 'Cargo',
  onboard_button_pronto: 'Estou pronto',
  onboard_convidado_email: 'Você foi convidado com o e-mail',
  onboard_instituicao: 'pela instituição',
  onboard_confirme_dados_reconhecimento_facial: 'Confirme seu dados e faça o reconhecimento facial para acessar o Instituto Caldeira.',
  onboard_confirme_dados_recepcao: 'Confirme seu dados para acessar o Instituto Caldeira.',
  onboard_informacoes_enviadas: 'Informações enviadas com sucesso',
  onboard_centralize_rosto: 'Centralize o seu rosto no espaço',
  onboard_rosto_capturado: 'Rosto capturado',
  onboard_capturar_imagem: 'Capturar imagem',
  onboard_capturar_novamente: 'Capturar novamente',
  onboard_enviar: 'Enviar',
  onboard_voltar: 'Voltar',
  onboard_foto_titulo: 'Tire uma foto',
  onboard_erro_camera: 'Não foi possível acessar a câmera. Verifique as permissões do navegador e tente novamente.',
  onboard_erro_enviar_foto: 'Erro ao enviar a foto. Tente novamente.',

  // Gêneros
  genero_nao_especificar: 'Não especificar',
  genero_masculino: 'Masculino',
  genero_feminino: 'Feminino',
  genero_outros: 'Outros',

  //Informe de acessos
  informe_acessos: 'Informe de acessos',
  evento: 'Evento',
  todos: 'Todos',
  buscar: 'Buscar',
  selecione_um_evento: 'Selecione um evento',
  selecione_um_colaborador_veiculo: 'Selecione um Colaborador/Veículo',

  nao_colaboradores: 'Colaboradores não encontrados!',
  nao_veiculos: 'Veículos não encontrados!',
  nao_busca: 'Nada encontrado!',

  ac_restrito: 'Acesso restrito',
  pg_moveis: 'Página destisnada a dispositivos movéis.',

  apr_img: 'Sua imagem foi para aprovação!',
  msn_img: 'Caso a imagem não seja adequada, recuse e envie um novo convite para o usuário',
  recusar: 'Recusar',
  aceitar: 'Aceitar',
  prosseguir: 'Prosseguir',
  capturar: 'Capturar',

  dicas_1: 'Não tire fotos borradas ou com sombras.',
  dicas_2: 'Não tire foto com pessoas ao seu lado ou com acessórios que cubram o seu rosto.',
  dicas_3: 'Use essa imagem como referência, imagem com boa iluminação é ideal para que fique legivel.',
  dicas_4: 'Use o nosso gabarito para posicionar o seu rosto e deixar sua imagem no padrão de envio correto!',

  qrcode: 'Qrcode',
  smartcard: 'SmartCard',
  facial: 'Facial',
  foto_pend: 'Foto pend.',
  pg_invalido: 'PÁGINA NÃO EXISTE!',
  vincular_facial: 'Vincular à facial',

  whats_msn1: 'Olá, ',
  whats_msn2: '. Clique no link para o cadastro da sua imagem no sistema de credenciamento do ',
  whats_msn3: '. O link tem validade de 24 horas. Lembre-se de efetuar o cadastro antes deste prazo, caso contrário o credenciamento será invalidado. Essa é uma mensagem automática, por favor não responda. Link',

  dicas: 'Dicas',
  credenciamento: 'Credenciamento',
  cod_acesso: 'CÓDIGOS DE ACESSO',
  search_codigos: 'Buscar códigos',
  nenhum_codigo_encontrado: 'Nenhum código encontrado ou já vinculado!',
  descricao: 'Descrição',
  codigo: 'Código',

  error1: 'Token expirado, por favor solicite novamamente o endereço para essa página ao seu gerente!',
  error2: 'Pessoa não cadastrada',
  error3: 'Você já cadastrou a imagem, por favor aguarde a aprovação!',
  error4: 'Não há cadastros',
  error5: 'Sem descrição',
  error6: 'Descrição muito curta',

  cpf_valida_obrigatoriedade: '*CPF é obrigatório',
  cpf_valida_numero_digitos: '*CPF precisa ter 11 números',
  cpf_invalido: '*CPF inválido',
  cnpj_invalido: '*CNPJ inválido',
  campo_obrigatorio: '*Campo Obrigatório',
  data_invalida: 'Data incorreta',
  data_nascimento_invalida: 'Por favor, insira uma data de nascimento valida.',

  _perfil: 'Perfil',
  _eventos: 'Eventos',
  _colaboradores: 'Colaboradores',
  _visitantes: 'Visitantes',
  _alunos: 'Alunos',
  _veiculos: 'Veículos',
  _codigo: 'Códigos de acesso',
  _informe: 'Informe de acessos',
  _sair: 'Sair',
  _portaria: 'Portaria',
  _empresa: 'Empresas',

  gerar: 'Gerar cód.',

  imply_nome_maiusculo: 'IMPLY',
  imply_nome_titlecase: 'Imply',

  concluir: 'Concluir',

  informe_nome_valido: 'Por favor, digite um nome válido',
  informe_email_valido: 'Por favor, digite um e-mail válido',
  informe_documento_valido: 'O documento informado não corresponde ao documento cadastrado',

  assinar_newsletter: 'Assinar newsletter e lista Caldeira',
  assinar_newsletter_outsider: 'Desejo receber newsletters, informações sobre programas, inscrições, eventos, iniciativas do Instituto Caldeira e comunicações relacionadas a parceiros e ações do ecossistema.',
  concordo_com_termos: 'Eu concordo com os termos',
  sucesso_importacao_pessoa: 'Importação realizada com sucesso!',
  sem_informacao: 'Não informada',
  empresa: 'Empresa',
  ou: 'ou',
  termo: 'Termo LGPD',
  ver_mais: 'Ver mais',
  ver_menos: 'Ver menos',
  gestor: 'Gestor',
  linha: 'Linha',
  info_modelo_csv_arquivos: 'Os arquivos CSV devem ser separados por ";" ou ",". Clique',
  aqui: 'aqui',
  info_modelo_csv_baixar: 'para baixar um modelo.',
  colaborador_campos_obrigatorios: ' Campos obrigatórios: Nome, E-mail.',
  visitante_campos_obrigatorios: ' Campos obrigatórios: Nome, E-mail, Data início da visita (ex: 01/01/2000 00:00), Data fim da visita (ex: 31/01/2000 23:59).',
  aluno_campos_obrigatorios: ' Campos obrigatórios: Nome, E-mail, Data início da visita (ex: 01/01/2000), Data fim da visita (ex: 31/01/2000).',

  pessoa_incluir_novo: "Adicionar pessoa",
  buscar_pessoas: "Buscar pessoa pelo nome ou e-mail",
  visitante: 'Visitante',
  aluno: 'Aluno',
  pessoa_email: "E-mail",
  pessoa_nome: "Nome",
  visita_duracao: "Duração",
  visita_motivo: "Motivos",
  visita_dthr_inicio: "Início",
  visita_dthr_fim: "Fim",
  visita_complemento: "Complemento",
  portaria_qrcode_visita: "Qrcode",
  send_email: "Enviar e-mail",
  voltar: "Voltar",
  add_visita: "Adicionar visita",
  ver_qrcode: "Ver QRcode visita",
  visitas_total_encontradas: "Total de visitas encontradas",
  visita_incluir_novo: "Incluir nova visita com QRcode",

  enviar_email_onboarding: 'Enviar e-mail de onboarding',
  deletar_colaborador: 'Deletar colaborador',
  deletar_aluno: 'Deletar aluno',
  editar_aluno: 'Editar Aluno',
  alterar_senha: 'Click aqui para alterar sua senha',
  permissionario: 'Permissionário',
  email_enviado: "E-mail enviado",

  notifications: 'Notificações',
  _news: 'Novidades',
  versao: 'Versão',
  app: 'APP',
  ver_news: 'Ver novidade',
  add_empresa: "Nova empresa",
  complete_onboarding: 'Completar onboarding',
  agenda_visitas: 'Visitas do visitante / Aluno',
  deletar_selecionados: "Deletar selecionado(s)",
  confirmacao_exclusao: "Tem certeza que deseja prosseguir com a exclusão?",
  visita_deletada_sucesso: "Visita(s) deletada(s) com sucesso!",
  pesquisar: "Pesquisar",
  limpar_filtros: "Limpar filtros",
  sim: "Sim",
  nao: "Não",
  passaporte: "Passaporte",
  acoes: "Ações",
  salvar: "Salvar",
  enviar_email_recuperacao_senha: "Enviar e-mail para cadastrar senha",
  sucesso_envio_recuperacao_senha: "O link para redefinir a senha foi enviado com sucesso!",
  imprimir: "Imprimir",
  baixar: "Baixar",
  pessoas: "Pessoas",
  sem_registro: "Sem registro",
  nome_empresa: "Nome empresa",
  empresa_ver_todas: 'Ver todas empresas',
  sucesso_cadastro_empresa: 'Empresa cadastrada com sucesso',
  sucesso_editar_empresa: 'Empresa editada com sucesso',
  sucesso_ativar_empresa: 'Empresa ativada com sucesso!',
  sucesso_inativar_empresa: 'Empresa inativada com sucesso!',
  ativar: 'Ativar',
  inativar: 'Inativar',
  deseja_ativar_empresa: 'Deseja ativar a empresa',
  deseja_inativar_empresa: 'Deseja inativar a empresa',
  buscar_cnpj: 'Buscar empresas pelo CNPJ',
  empresas_total_encontradas: 'Total de empresas cadastradas',
  empresa_incluir_nova: 'Incluir nova empresa',
  sucesso_impressao: 'Impressão realizada com sucesso!',
  erro_impressao: 'Algo inesperado ocorreu durante o processo de impressão.',
  imprimindo: 'Imprimindo...',

  merge_msg_1: "Foi identificada a existência de um cadastro com este documento utilizando o e-mail: ",
  merge_msg_2: "deseja unificar os cadastros?",
  merge_msg_3: "Caso confirme o nome e e-mail deste cadastro serão inseridos no cadastro já existente!",

  remove_foto: "Foto removida com sucesso",
  visualizar_foto: "Visualizar foto",
  delete_photo: "Deletar foto",
  ver_foto: "Ver foto",
  statusFacial: "Status Facial",
  ultimaAtualizacao: "Última atualização",

  status: "Status",
  status_realizado: "Realizado",
  sem_registros: "Sem registros",
  sincronizacao: "Sincronização",
  label_confirmar_email: "Confirme seu e-mail para prosseguir",
  confirmar_email: "Confirmar e-mail",
  email_diferente: "O e-mail informado não corresponde ao cadastrado.",
  categoria: "Categoria",

  portaria_importar_lista: 'Importar lista de pessoas',
  portaria_campos_obrigatorios: ' Campos obrigatórios: Início, Fim.',
  portaria_motivo_obrigatorio: "Preencha motivo da visita para prosseguir.",
  portaria_tipo_documento: "Tipo de documento",

  no_data: "Sem dados",
  qrcode_complete_onboarding: "Leia esse QR Code e complete seu onboarding",
  qrcode_complete_onboarding_recepcao: "Use este QR Code para acessar o Caldeira",
  qrcode_onboarding: "QR Code onboarding",
  loading: "Carregando...",
  sucesso_cadastro_visita: "Cadastro realizado com sucesso!",
  sucesso_cadastro_visita_msg: "Um link de onboarding foi enviado para o e-mail da visita.",
  enviar_qrcode_visita_email: "Enviar QRCode da visita por e-mail",
};
